import React from 'react';
import CommunityImg from '../../Common/CommunityImg/CommunityImg';
import { default as CreativeFollowImgWeb } from '../../../images/creative-follow-bottom-img.svg';
import { default as CreativeFollowImgMobile } from '../../../images/creative_follow_bg_mobile.svg';
import './CreativeFollow.scss';
import Wild from '../../Wild/Wild'
import { graphql, useStaticQuery } from "gatsby"

export default function CreativeFollow({data}) {

  const { title, titleCaption, subTitle, subTitleTag, tagSlug, videos } = data.allContentfulElbrusPagesInTheWild.nodes[0]
  const ghostPosts = useStaticQuery(graphql`
    query {
      allGhostPost(
        filter: {tags: {elemMatch: {slug: {eq: "hash-creativecommunity"}}}}
        sort: {order: DESC, fields: created_at}
        limit: 9
      ) {
        nodes {
          feature_image
          slug
          title
        }
      }
    }
  `)

  return (
    <>
      <div className="creative-follow-container">
        <Wild
          wildImg={""}
          title={title}
          titleCaption={titleCaption}
          subTitle={subTitle}
          subTitleTag={subTitleTag}
          posts={ghostPosts.allGhostPost.nodes}
          videos={videos}
        />
        <div className="creative-follow-bottom-img web">
          <CommunityImg src={CreativeFollowImgWeb} alt="event follow pic" />
        </div>
        <div className="creative-follow-bottom-img mobile">
          <CommunityImg src={CreativeFollowImgMobile} alt="event follow pic" />
        </div>
      </div>
    </>
  )
}
